// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","wrapper":"styles_wrapper__fsZCk","flow":"styles_flow__c9Jd3","success":"styles_success__6KZwf"};